<section>
  <div class="container-fluid">
    <div class="commentSection">
      <hr />
      <h2 class="heading">Why Customers love <br /> working with us</h2>
    </div>

    <div class="scrollbar-container">
      <div class="scrollbar-track">
        <div class="scrollbar-thumb" [style.width.%]="scrollbarWidth" [style.left.%]="scrollbarPosition"></div>
      </div>
    </div>

    <div #scrollContainer class="customerSection" (mouseenter)="pauseScroll()" (mouseleave)="resumeScroll()">
      <div
        class="testimonialCard"
        *ngFor="let item of customer; let i = index"
        [ngClass]="{'active': i === currentSlide, 'highlighted': i === highlightedSlide}"
        (click)="onCardClick(i)"
      >
        <p class="comment">
          {{ item.customerComment }}
        </p>
        <h6 class="customerName">{{ item.customerName }}</h6>
        <p class="customerOccupation">{{ item.customerOccupation }}</p>
        <div class="stars">
          <ng-container *ngFor="let star of [1, 2, 3, 4, 5]">
            <span class="star" [class.filled]="star <= item.rating">&#9733;</span>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</section>




<!-- <section>
  <div class = "container-fluid">
    <div class = "commentSection">
      <hr />
      <h2 class = "heading">Why Customers love <br /> working with us</h2>
      <p class="comment">
        {{ currentCustomer?.customerComment }}
      </p>
      <img src = "../../../../assets/images/arrow-left.png" alt = "left-arrow" class = "leftArrow" (click)="onArrowClick('left')">
      <img src = "../../../../assets/images/arrow-left.png" alt = "right-arrow" class = "rightArrow" (click)="onArrowClick('right')">
    </div>
    <div class = "customerSection">
      <div class = "customers" *ngFor="let item of customer; let i = index" (slide)="onSlide($event.current)">
        <img [src]="item.customerImage" alt="" class="img-fluid d-block rounded-circle" width="150" height="150" [ngClass]="{'active': i === currentSlide, 'inactive': i !== currentSlide}">
        <h6 class="customerName" style = "font-size: 18px;color: #000;" [ngClass]="{'active': i === currentSlide, 'inactive': i !== currentSlide}">{{ item.customerName }}</h6>
        <p class="customerOccupation" style = "font-size: 16px;color:#000;" [ngClass]="{'active': i === currentSlide, 'inactive': i !== currentSlide}">{{ item.customerOccupation }}</p>
      </div>
    </div>
  </div>
</section> -->
